export enum OrderItemType {
  ACCOMMODATION = 'accommodation',
}

export const UpsellableOrderItemTypes = [
  OrderItemType.ACCOMMODATION,
]

export enum BookingDetailsV2PageTypes {
  CONFIRMATION_PAGE = 'booking-confirmation',
  MY_ESCAPES_ORDER_PAGE = 'my-escapes-order',
}

export enum ItemOperation {
  REFUND = 'refund',
}

// Must stay in lockstep with svc-order's OrderRelationshipType, which the published
// contract types as a plain string rather than a union, so there is nothing to import yet.
export const RELATIONSHIP_TYPE_FLIGHT_POST_PURCHASE_FEE = 'flight_post_purchase_fee'
